import { Box, Link, ListItemText, CircularProgress, Modal, IconButton, Typography, Paper, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { NavLink as RouterLink } from "react-router-dom";
import SvgIconStyle from "src/components/SvgIconStyle";
import { useTranslation } from "react-i18next";
import useIsHoldingTank from "src/hooks/use-is-holding-tank";
import { useAppConfig } from "src/store/app-config";
import { isExternalLink } from "..";
import Iconify from "../../Iconify";
import { ListItemIconStyle, ListItemStyle, ListItemTextStyle } from "./style";
import { useState } from "react";
import axiosInstance from "src/utils/axios";
import axios from "axios";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from 'react-router-dom';
import { PATH_USER } from "src/routes/paths";
import CloseIcon from '@mui/icons-material/Close';
import { CREATORPRO_URL } from "src/config";
import { SUPPORT_URL } from "src/config";
import CreatorProPopup from "src/pages/user/creatorPro/components/CreatorProPopup.jsx"
import { useSnackbar } from 'notistack';
import { X_API_KEY, HOUSE_TV_WEBSITE_URL ,GATEWAY_URL,MARCH_MADNESS_URL} from "src/config";
import useAuth from "src/hooks/useAuth";

const getDeviceType = () =>
  typeof window !== "undefined" && window.innerWidth <= 768 ? "mobile" : "web";


NavItemRoot.propTypes = {
  active: PropTypes.bool,
  open: PropTypes.bool,
  isCollapse: PropTypes.bool,
  onOpen: PropTypes.func,
  item: PropTypes.shape({
    children: PropTypes.array,
    icon: PropTypes.any,
    info: PropTypes.any,
    path: PropTypes.string,
    title: PropTypes.string,
  }),
};

export function NavItemRoot({
  item,
  isCollapse,
  open = false,
  active,
  onOpen,
}) {
  const { title, path, icon, info, children, isAffiliate, isLead } = item;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [loadingBilling, setLoadingBilling] = useState(false);
  const [loadingBillingReportLevel, setLoadingBillingReportLevel] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showLaunchPopup, setShowLaunchPopup] = useState(false); // New state for LaunchPopup
  const theme = useTheme();
  const navigate = useNavigate();
  const [showCreatorProPopup, setShowCreatorProPopup] = useState(false); // NEW: Add this
  const [loadingSSO, setLoadingSSO] = useState(false);
  const billingEnabled = false;
  const { user } = useAuth();
  const [isOpening, setIsOpening] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const isHoldingTank = useIsHoldingTank();
  const disabledMenu = isHoldingTank && Boolean(isAffiliate);
  const { config } = useAppConfig();
  const leadsEnable = Boolean(config?.leads_enable?.status);
  if (isLead && !leadsEnable) return null;

  const handleComingSoon = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowPopup(true);
  };

  const handleLaunchPopup = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowLaunchPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleCloseLaunchPopup = () => {
    setShowLaunchPopup(false);
  };

  const handleCreatorProPopup = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowCreatorProPopup(true);
  };

  const handleCloseCreatorProPopup = () => {
    setShowCreatorProPopup(false);
  };

  const handleBillingSsoRedirect = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (loadingBilling) return;
    setLoadingBilling(true);

    try {
      const { data } = await axiosInstance.get("/api/sso/redirect");
      const { status, sso_token } = data;

      if (status && sso_token) {
        navigate(PATH_USER.billing);
      } else {
        throw new Error("Invalid Billing SSO response");
      }
    } catch (err) {
      console.error("Failed to connect to Billing:", err);
    } finally {
      setLoadingBilling(false);
    }
  };
  const handleBillingReportLevelSsoRedirect = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (loadingBillingReportLevel) return;
    setLoadingBillingReportLevel(true);

    try {
      const { data } = await axiosInstance.get("/api/sso/redirect");
      const { status, sso_token } = data;

      if (status && sso_token) {
        navigate(PATH_USER.genealogy.billingreport);
      } else {
        throw new Error("Invalid Billing SSO response");
      }
    } catch (err) {
      console.error("Failed to connect to Billing:", err);
    } finally {
      setLoadingBillingReportLevel(false);
    }
  };

  const handleCreatorProLink = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Open the popup instead of redirecting
    setShowCreatorProPopup(true);
  };

  const handleSupportLink = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const url = SUPPORT_URL;
    try {
      window.location.href = url;
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } catch (err) {
      console.error("Failed to connect to support:", err);
    }
  };

  const renderContent = (
    <>
      {icon && (
        <ListItemIconStyle>
          <SvgIconStyle src={icon} sx={{ width: 1, height: 1 }} />
        </ListItemIconStyle>
      )}
      <ListItemTextStyle
        disableTypography
        primary={t(title)}
        isCollapse={isCollapse}
      />
      {loading && <CircularProgress size={16} sx={{ ml: 1, color: "text.secondary" }} />}
      {loadingBilling && <CircularProgress size={16} sx={{ ml: 1, color: "text.secondary" }} />}
      {!isCollapse && (
        <>
          {info && info}
          {children?.length > 0 && <ArrowIcon open={open} />}
        </>
      )}
    </>
  );

  // Collapsible parent
  if (children?.length > 0) {
    return (
      <>
        <ListItemStyle
          disabled={disabledMenu}
          onClick={onOpen}
          activeRoot={active}
        >
          {renderContent}
        </ListItemStyle>
        <ComingSoonPopup open={showPopup} onClose={handleClosePopup} />
      </>
    );
  }

  // Special handlers with tooltip AND popup
  if (path === "handleList") {
    return (
      <>
        <Tooltip title="Coming 2026" placement="right-start" arrow>
          <ListItemStyle
            disabled={disabledMenu}
            onClick={handleComingSoon}
            activeRoot={active}
            sx={{
              cursor: "pointer",
              '&:hover': {
                backgroundColor: 'action.hover',
              }
            }}
          >
            {renderContent}
          </ListItemStyle>
        </Tooltip>
        <ComingSoonPopup open={showPopup} onClose={handleClosePopup} />
      </>
    );
  }

  if (path === "handleCreatorProLink") {
    return (
      <>
        <ListItemStyle
          disabled={disabledMenu}
          onClick={handleCreatorProPopup} // Use the popup handler
          activeRoot={active}
          sx={{
            cursor: "pointer",
            '&:hover': {
              backgroundColor: 'action.hover',
            }
          }}
        >
          {renderContent}
        </ListItemStyle>
        {/* Add the CreatorProPopup */}
        <CreatorProPopup
          open={showCreatorProPopup}
          onClose={handleCloseCreatorProPopup}
        />
      </>
    );
  }

  // if (path === "handleSSORedirect") {
  //   return (
  //     <>
  //         <ListItemStyle
  //           disabled={disabledMenu}
  //           onClick={handleLaunchPopup}
  //           activeRoot={active}
  //           sx={{
  //             cursor: "pointer",
  //             '&:hover': {
  //               backgroundColor: 'action.hover',
  //             }
  //           }}
  //         >
  //           {renderContent}
  //         </ListItemStyle>
  //       {/* <LaunchPopup open={showLaunchPopup} onClose={handleCloseLaunchPopup} /> */}
  //     </>
  //   );
  // }
  if (path === "handleSSORedirect") {
    const handleOpen1HouseTV = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const newWindow = window.open("", "_blank");

        if (!newWindow) {
          enqueueSnackbar("Popup blocked. Please allow popups.", {
            variant: "error",
          });
          return;
        }

        try {
          setIsOpening(true);

          const refresh_token = localStorage.getItem("accessToken");
          if (!refresh_token) {
            throw new Error("Missing refresh token (access token) for SSO.");
          }

          const { data: ssoData } = await axiosInstance.get("/api/sso/redirect");
          const { status, sso_token } = ssoData || {};

          if (!status || !sso_token) {
            throw new Error("Invalid SSO redirect response.");
          }

          const { data: verifyData } = await axiosInstance.post(
            "/api/sso-verify-token",
            { sso_token, refresh_token },
            { headers: { "Content-Type": "application/json" } }
          );

          const accessToken =
            verifyData?.accessToken ||
            verifyData?.access_token ||
            verifyData?.data?.accessToken ||
            verifyData?.data?.access_token;

          const refreshToken =
            verifyData?.refreshToken ||
            verifyData?.refresh_token ||
            verifyData?.data?.refreshToken ||
            verifyData?.data?.refresh_token;

          if (!accessToken || !refreshToken) {
            throw new Error("Missing access/refresh token from SSO verification.");
          }

          const customerId = user?.user_profile?.user_id;
          if (!customerId) {
            throw new Error("Missing customerId for SSO.");
          }

          const { data: signinSsoData } = await axios.post(
            GATEWAY_URL,
            {
              customerId: String(customerId),
              accessToken,
              refreshToken,
              noRedirect: 1,
              device: getDeviceType(),
            },
            {
              headers: {
                "X-API-Key": X_API_KEY,
                "Content-Type": "application/json",
              },
            }
          );

          const redirectUrl =
            signinSsoData?.redirectUrl || signinSsoData?.data?.redirectUrl;

          if (!redirectUrl) {
            throw new Error("Missing redirectUrl from signin-sso response.");
          }

          newWindow.location.href = redirectUrl;

        } catch (err) {
          console.error(err);

          if (newWindow) {
            newWindow.close();
          }

          enqueueSnackbar("Failed to connect to 1House TV. Please try again.", {
            variant: "error",
          });
        } finally {
          setIsOpening(false);
        }
      };

    return (
      <>
        {/* <ListItemStyle
          disabled={disabledMenu || loadingSSO}
          onClick={handleSSORedirect}
          activeRoot={active}
          sx={{ cursor: loadingSSO ? "wait" : "pointer" }}
        >
          {renderContent}
          {loadingSSO && <CircularProgress size={16} sx={{ ml: 1, color: "text.secondary" }} />}
        </ListItemStyle> */}
           <ListItemStyle
              disabled={disabledMenu}                // loadingSSO removed
              onClick={handleOpen1HouseTV}
              activeRoot={active}
              sx={{ cursor: "pointer" }}             // loading condition removed
            >
              {renderContent}
              {/* CircularProgress removed */}
            </ListItemStyle>
        {/* LaunchPopup is completely removed – no longer needed */}
      </>
    );
  }

//   if (path === "handleMarchMadness") {
//   const handleMarchMadnessRedirect = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     window.open(MARCH_MADNESS_URL, "_blank");
//   };

//   return (
//     <ListItemStyle
//       disabled={disabledMenu}
//       onClick={handleMarchMadnessRedirect}
//       activeRoot={active}
//       sx={{ cursor: "pointer" }}
//     >
//       {renderContent}
//     </ListItemStyle>
//   );
// }

  if (path === "handleBillingSsoRedirect") {
    return (
      <>
        <ListItemStyle
          disabled={disabledMenu || loadingBilling}
          onClick={handleBillingSsoRedirect}
          activeRoot={active}
          sx={{ cursor: loadingBilling ? "wait" : "pointer" }}
        >
          {renderContent}
        </ListItemStyle>
        <ComingSoonPopup open={showPopup} onClose={handleClosePopup} />
      </>
    );
  }

  if (path === "handleBillingLevelView") {
    return (
      <>
        <ListItemStyle
          disabled={disabledMenu || loadingBillingReportLevel}
          onClick={handleBillingReportLevelSsoRedirect}
          activeRoot={active}
          sx={{ cursor: loadingBillingReportLevel ? "wait" : "pointer" }}
        >
          {renderContent}
        </ListItemStyle>
      </>
    );
  }

  if (path === "handleBillingReport") {
    const handleBillingReportClick = async (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (window.location.pathname.includes('/admin/billing/')) {
        return;
      }
      window.location.href = '/admin/billing/index';
    };
    return (
      <>
        <ListItemStyle
          disabled={disabledMenu || loadingBilling}
          onClick={handleBillingReportClick}
          activeRoot={active}
          sx={{ cursor: loadingBilling ? "wait" : "pointer" }}
        >
          {renderContent}
        </ListItemStyle>
      </>
    );
  }

  if (path === "handleCreatorProLink") {
    return (
      <>
        <ListItemStyle
          disabled={disabledMenu}
          onClick={handleCreatorProPopup} // Use the popup handler
          activeRoot={active}
          sx={{
            cursor: "pointer",
            '&:hover': {
              backgroundColor: 'action.hover',
            }
          }}
        >
          {renderContent}
        </ListItemStyle>
        {/* Add the CreatorProPopup */}
        <CreatorProPopup
          open={showCreatorProPopup}
          onClose={handleCloseCreatorProPopup}
        />
      </>
    );
  }
  // External link
  if (isExternalLink(path)) {
    return (
      <>
        <ListItemStyle
          component={Link}
          href={path}
          target="_blank"
          rel="noopener"
          disabled={disabledMenu}
          activeRoot={active}
        >
          {renderContent}
        </ListItemStyle>
        <ComingSoonPopup open={showPopup} onClose={handleClosePopup} />
      </>
    );
  }

  // Normal internal route
  return (
    <>
      <ListItemStyle
        component={RouterLink}
        to={path}
        disabled={disabledMenu}
        activeRoot={active}
      >
        {renderContent}
      </ListItemStyle>
      <ComingSoonPopup open={showPopup} onClose={handleClosePopup} />
      <CreatorProPopup
        open={showCreatorProPopup}
        onClose={handleCloseCreatorProPopup}
      />
    </>
  );
}

NavItemSub.propTypes = {
  active: PropTypes.bool,
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  item: PropTypes.shape({
    children: PropTypes.array,
    info: PropTypes.any,
    path: PropTypes.string,
    title: PropTypes.string,
  }),
};

export function NavItemSub({ item, open = false, active = false, onOpen }) {
  const { title, path, info, children, isAffiliate, isKyc } = item;
  const { t } = useTranslation();
  const [showPopup, setShowPopup] = useState(false);
  const [showLaunchPopup, setShowLaunchPopup] = useState(false); // New state for LaunchPopup

  const isHoldingTank = useIsHoldingTank();
  const disabledMenu = isHoldingTank && Boolean(isAffiliate);
  const { config } = useAppConfig();
  const kycEnable = Boolean(config?.kyc_enable?.status);
  const [loadingBillingReportLevel, setLoadingBillingReportLevel] = useState(false);
  const navigate = useNavigate();
  const [loadingSSO, setLoadingSSO] = useState(false);
  const billingEnabled = false;
  const { user } = useAuth();
  const [isOpening, setIsOpening] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  
  if (isKyc && !kycEnable) return null;


  const handleBillingReportLevelSsoRedirect = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (loadingBillingReportLevel) return;
    setLoadingBillingReportLevel(true);

    try {
      const { data } = await axiosInstance.get("/api/sso/redirect");
      const { status, sso_token } = data;

      if (status && sso_token) {
        navigate(PATH_USER.genealogy.billingreport);
      } else {
        throw new Error("Invalid Billing SSO response");
      }
    } catch (err) {
      console.error("Failed to connect to Billing:", err);
    } finally {
      setLoadingBillingReportLevel(false);
    }
  };

  const handleComingSoon = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowPopup(true);
  };

  const handleLaunchPopup = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowLaunchPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleCloseLaunchPopup = () => {
    setShowLaunchPopup(false);
  };

  const renderContent = (
    <>
      <DotIcon active={active} />
      <ListItemText disableTypography primary={t(title)} />
      {info && info}
      {children && <ArrowIcon open={open} />}
    </>
  );

  if (children?.length > 0) {
    return (
      <>
        <ListItemStyle
          disabled={disabledMenu}
          onClick={onOpen}
          activeSub={active}
          subItem
        >
          {renderContent}
        </ListItemStyle>
        <ComingSoonPopup open={showPopup} onClose={handleClosePopup} />
      </>
    );
  }

  // Special handlers with tooltip AND popup for sub items
  if (path === "handleCreatorPlusLink" || path === "handleList") {
    return (
      <>
        <Tooltip title="Coming 2026" placement="right-start" arrow>
          <ListItemStyle
            disabled={disabledMenu}
            onClick={handleComingSoon}
            activeSub={active}
            subItem
            sx={{
              cursor: "pointer",
              '&:hover': {
                backgroundColor: 'action.hover',
              }
            }}
          >
            {renderContent}
          </ListItemStyle>
        </Tooltip>
        <ComingSoonPopup open={showPopup} onClose={handleClosePopup} />
      </>
    );
  }

  // if (path === "handleSSORedirect") {
  //   return (
  //     <>
  //         <ListItemStyle
  //           disabled={disabledMenu}
  //           onClick={handleLaunchPopup}
  //           activeSub={active}
  //           subItem
  //           sx={{
  //             cursor: "pointer",
  //             '&:hover': {
  //               backgroundColor: 'action.hover',
  //             }
  //           }}
  //         >
  //           {renderContent}
  //         </ListItemStyle>
  //       {/* <LaunchPopup open={showLaunchPopup} onClose={handleCloseLaunchPopup} /> */}
  //     </>
  //   );
  // }
  if (path === "handleSSORedirect") {
    const handleOpen1HouseTV = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const newWindow = window.open("", "_blank");

        if (!newWindow) {
          enqueueSnackbar("Popup blocked. Please allow popups.", {
            variant: "error",
          });
          return;
        }

        try {
          setIsOpening(true);

          const refresh_token = localStorage.getItem("accessToken");
          if (!refresh_token) {
            throw new Error("Missing refresh token (access token) for SSO.");
          }

          const { data: ssoData } = await axiosInstance.get("/api/sso/redirect");
          const { status, sso_token } = ssoData || {};

          if (!status || !sso_token) {
            throw new Error("Invalid SSO redirect response.");
          }

          const { data: verifyData } = await axiosInstance.post(
            "/api/sso-verify-token",
            { sso_token, refresh_token },
            { headers: { "Content-Type": "application/json" } }
          );

          const accessToken =
            verifyData?.accessToken ||
            verifyData?.access_token ||
            verifyData?.data?.accessToken ||
            verifyData?.data?.access_token;

          const refreshToken =
            verifyData?.refreshToken ||
            verifyData?.refresh_token ||
            verifyData?.data?.refreshToken ||
            verifyData?.data?.refresh_token;

          if (!accessToken || !refreshToken) {
            throw new Error("Missing access/refresh token from SSO verification.");
          }

          const customerId = user?.user_profile?.user_id;
          if (!customerId) {
            throw new Error("Missing customerId for SSO.");
          }

          const { data: signinSsoData } = await axios.post(
            GATEWAY_URL,
            {
              customerId: String(customerId),
              accessToken,
              refreshToken,
              noRedirect: 1,
              device: getDeviceType(),
            },
            {
              headers: {
                "X-API-Key": X_API_KEY,
                "Content-Type": "application/json",
              },
            }
          );

          const redirectUrl =
            signinSsoData?.redirectUrl || signinSsoData?.data?.redirectUrl;

          if (!redirectUrl) {
            throw new Error("Missing redirectUrl from signin-sso response.");
          }

          newWindow.location.href = redirectUrl;

        } catch (err) {
          console.error(err);

          if (newWindow) {
            newWindow.close();
          }

          enqueueSnackbar("Failed to connect to 1House TV. Please try again.", {
            variant: "error",
          });
        } finally {
          setIsOpening(false);
        }
      };
    return (
      <>
        {/* <ListItemStyle
          disabled={disabledMenu || loadingSSO}
          onClick={handleSSORedirect}
          activeSub={active}
          subItem
          sx={{ cursor: loadingSSO ? "wait" : "pointer" }}
        >
          {renderContent}
          {loadingSSO && <CircularProgress size={16} sx={{ ml: 1, color: "text.secondary" }} />}
        </ListItemStyle> */}
         <ListItemStyle
            disabled={disabledMenu}
            onClick={handleOpen1HouseTV}
            activeSub={active}
            subItem
            sx={{ cursor: "pointer" }}
          >
            {renderContent}
            {/* CircularProgress removed */}
          </ListItemStyle>
      </>
    );
  }

//   if (path === "handleMarchMadness") {
//   const handleMarchMadnessRedirect = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     window.open(MARCH_MADNESS_URL, "_blank");
//   };

//   return (
//     <ListItemStyle
//       disabled={disabledMenu}
//       onClick={handleMarchMadnessRedirect}
//       activeSub={active}
//       subItem
//       sx={{ cursor: "pointer" }}
//     >
//       {renderContent}
//     </ListItemStyle>
//   );
// }

  if (path === "handleBillingLevelView") {
    return (
      <>
        <ListItemStyle
          disabled={disabledMenu || loadingBillingReportLevel}
          onClick={handleBillingReportLevelSsoRedirect}
          activeSub={active}
          subItem
          sx={{ cursor: loadingBillingReportLevel ? "wait" : "pointer" }}
        >
          {renderContent}
        </ListItemStyle>
      </>
    );
  }

  if (isExternalLink(path)) {
    return (
      <>
        <ListItemStyle
          component={Link}
          href={path}
          target="_blank"
          rel="noopener"
          disabled={disabledMenu}
          activeSub={active}
          subItem
        >
          {renderContent}
        </ListItemStyle>
        <ComingSoonPopup open={showPopup} onClose={handleClosePopup} />
      </>
    );
  }

  return (
    <>
      <ListItemStyle
        component={RouterLink}
        to={path}
        disabled={disabledMenu}
        activeSub={active}
        subItem
      >
        {renderContent}
      </ListItemStyle>
      <ComingSoonPopup open={showPopup} onClose={handleClosePopup} />
    </>
  );
}

// Popup Component - Fixed position to prevent multiple instances issue
const ComingSoonPopup = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="coming-soon-popup"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper
        sx={{
          position: 'relative',
          width: { xs: '90%', sm: 400 },
          maxWidth: 400,
          p: 4,
          borderRadius: 2,
          boxShadow: 24,
          bgcolor: 'background.paper',
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'primary.main',
            '&:hover': {
              color: 'text.primary',
            }
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Content */}
        <Box sx={{ textAlign: 'center', mt: 2 }}>
          {/* Optional: Add an icon */}
          <Box
            sx={{
              width: 80,
              height: 80,
              mx: 'auto',
              mb: 3,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              bgcolor: 'primary.lighter',
              color: 'primary.main',
            }}
          >
            <Iconify icon="mdi:calendar-star" width={40} height={40} />
          </Box>

          <Typography
            variant="h4"
            sx={{
              mt: 3,
              mb: 2,
              fontWeight: 700,
              color: 'text.primary',
              // background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
              backgroundColor: "text.primary",
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Coming 2026
          </Typography>

          {/* Action Button */}
          <Box sx={{ mt: 4 }}>
            <IconButton
              onClick={onClose}
              sx={{
                bgcolor: 'primary.main',
                color: 'white',
                px: 4,
                py: 1,
                borderRadius: 2,
                '&:hover': {
                  bgcolor: 'primary.dark',
                }
              }}
            >
              Got it
            </IconButton>
          </Box>
        </Box>
      </Paper>
    </Modal>
  );
};

ComingSoonPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

// LaunchPopup Component - Add this right after ComingSoonPopup
// const LaunchPopup = ({ open = false, onClose }) => {
//   const greenTickLocation = "/icons/popup/launchPopup/greenTick.svg";
//   const blankTickLocation = "/icons/popup/launchPopup/blankTick.svg";

//   const preLaunchFeature = [
//     { key: `pre-1`, tick: true, text: "Early access to select live streams" },
//     { key: `pre-2`, tick: true, text: "Select on-demand replays" },
//     { key: `pre-3`, tick: true, text: "Community access" },
//     { key: `pre-4`, tick: true, text: "Founding member pricing locked" },
//     { key: `pre-5`, tick: true, text: "Priority onboarding at launch" },
//     { key: `pre-6`, tick: false, text: "1House App (Full version)" },
//     { key: `pre-7`, tick: false, text: "Full live stream schedule" },
//     { key: `pre-8`, tick: false, text: "Complete education library" },
//     { key: `pre-9`, tick: false, text: "Creator & Platform tools" },
//   ];

//   const postLaunchFeature = [
//     { key: `post-1`, tick: true, text: "Full access to live streams" },
//     { key: `post-2`, tick: true, text: "Full replay and recording library" },
//     { key: `post-3`, tick: true, text: "1House Community ecosystem" },
//     { key: `post-4`, tick: true, text: "Access to first 5000 member perks" },
//     { key: `post-5`, tick: true, text: "Priority access at launch" },
//     { key: `post-6`, tick: true, text: "1House App (Full version)" },
//     { key: `post-7`, tick: true, text: "Multi Industry education hub" },
//     { key: `post-8`, tick: true, text: "Complete education library" },
//     { key: `post-9`, tick: true, text: "Creator & Platform tools" },
//   ];

//   return (
//     <Modal
//       open={open}
//       onClose={onClose}
//       aria-labelledby="launch-popup"
//       sx={{
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         overflow: 'auto',
//         py: 2,
//       }}
//     >
//       <Paper
//         sx={{
//           position: 'relative',
//           width: { xs: '95%', md: 900 },
//           maxWidth: 900,
//           maxHeight: '90vh',
//           overflow: 'auto',
//           p: 4,
//           borderRadius: 2,
//           boxShadow: 24,
//           bgcolor: 'background.paper',
//         }}
//       >
//         {/* Close Button */}
//         <IconButton
//           onClick={onClose}
//           sx={{
//             position: 'absolute',
//             right: 8,
//             top: 8,
//             zIndex: 1,
//             color: 'primary.main',
//             '&:hover': {
//               color: 'text.primary',
//             }
//           }}
//         >
//           <CloseIcon />
//         </IconButton>

//         <Box sx={{ paddingTop: "40px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "start", minWidth: "100%" }}>
//           <Typography
//             sx={{
//               fontSize: "48px",
//               textTransform: "uppercase",
//               textAlign: "center",
//               width: "100%",
//               fontWeight: 700,
//             }}
//           >
//             launching february 13
//           </Typography>
//           <Typography sx={{ fontSize: "16px", textAlign: "center", width: "100%", textWrap: "wrap", letterSpacing: "2px", lineHeight: "12.0px", mb: 4 }}>
//             You&apos;re viewing a pre-launch feature. This section unlocks on <Typography component="span" sx={{ fontWeight: 800 }}>
//               February 13 as part of our official platform rollout.
//             </Typography>
//           </Typography>

//           {/* Content Box */}
//           <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
//             <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" }, gap: "40px", margin: "20px 0px auto", width: "fit-content", }}>

//               {/* First Column */}
//               <Box sx={{ display: "grid", columnCount: 1, gap: "6px" }}>
//                 {/* Green Box */}
//                 <Box sx={{ backgroundColor: "#3BD464", borderRadius: "8px", padding: "5px 6px 8px 6px", minHeight: "32px", minWidth: "170px" }}>
//                   <Typography sx={{ fontSize: "12px", textTransform: "uppercase", width: "100%", textAlign: "center", letterSpacing: "2px", mb: "-8px" }}>
//                     status: active
//                   </Typography>
//                   <Typography sx={{ fontSize: "20px", textTransform: "uppercase", width: "100%", textAlign: "center", fontWeight: 600 }}>
//                     pre-launch access
//                   </Typography>
//                 </Box>
//                 <Box sx={{ display: "flex", flexDirection: "column", marginTop: "18px" }}>
//                   {preLaunchFeature.map((item) => (
//                     <Box key={item.key} sx={{ display: "flex", gap: "8px", justifyContent: "start", alignItems: "flex-start", mb: 2 }}>
//                       <Box sx={{ width: 24, height: 24, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
//                         <img
//                           alt="tick"
//                           src={item.tick ? greenTickLocation : blankTickLocation}
//                           style={{ width: "100%", height: "100%", objectFit: "contain" }}
//                         />
//                       </Box>
//                       <Typography sx={{ lineHeight: 1.2, fontSize: "14px" }}>
//                         {item.text}
//                       </Typography>
//                     </Box>
//                   ))}
//                 </Box>
//               </Box>

//               {/* Second Column */}
//               <Box sx={{ display: "grid", columnCount: 1, gap: "6px" }}>
//                 {/* Green Box */}
//                 <Box sx={{ backgroundColor: "#3BD464", borderRadius: "8px", padding: "5px 6px 8px 6px", minHeight: "32px", minWidth: "170px" }}>
//                   <Typography sx={{ fontSize: "12px", textTransform: "uppercase", width: "100%", textAlign: "center", letterSpacing: "2px", mb: "-8px" }}>
//                     status: unlock february 13
//                   </Typography>
//                   <Typography sx={{ fontSize: "20px", textTransform: "uppercase", width: "100%", textAlign: "center", fontWeight: 600 }}>
//                     full platform access
//                   </Typography>
//                 </Box>
//                 <Box sx={{ display: "flex", flexDirection: "column", marginTop: "18px" }}>
//                   {postLaunchFeature.map((item) => (
//                     <Box key={item.key} sx={{ display: "flex", gap: "8px", justifyContent: "start", alignItems: "flex-start", mb: 2 }}>
//                       <Box sx={{ width: 24, height: 24, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
//                         <img
//                           alt="tick"
//                           src={item.tick ? greenTickLocation : blankTickLocation}
//                           style={{ width: "100%", height: "100%", objectFit: "contain" }}
//                         />
//                       </Box>
//                       <Typography sx={{ lineHeight: 1.2, fontSize: "14px" }}>
//                         {item.text}
//                       </Typography>
//                     </Box>
//                   ))}
//                 </Box>
//               </Box>
//             </Box>
//           </Box>
//         </Box>
//       </Paper>
//     </Modal>
//   );
// };

// LaunchPopup.propTypes = {
//   open: PropTypes.bool.isRequired,
//   onClose: PropTypes.func.isRequired,
// };

export function DotIcon({ active }) {
  return (
    <ListItemIconStyle>
      <Box
        component="span"
        sx={{
          width: 4,
          height: 4,
          borderRadius: "50%",
          bgcolor: "text.disabled",
          transition: (theme) =>
            theme.transitions.create("transform", {
              duration: theme.transitions.duration.shorter,
            }),
          ...(active && {
            transform: "scale(2)",
            bgcolor: "primary.main",
          }),
        }}
      />
    </ListItemIconStyle>
  );
}

export function ArrowIcon({ open }) {
  return (
    <Iconify
      icon={open ? "eva:arrow-ios-downward-fill" : "eva:arrow-ios-forward-fill"}
      sx={{ width: 16, height: 16, ml: 1 }}
    />
  );
}
